import { atom } from "jotai";
import { EntityValue } from "@/model";

export const editingEntityValueAtom = atom<EntityValue|undefined>();
